import { render } from "./ShareScreen.vue?vue&type=template&id=16b993e4"
import script from "./ShareScreen.vue?vue&type=script&lang=js"
export * from "./ShareScreen.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__